



















import Vue from 'vue'
import { eventHub } from '@/store/eventHub'

interface SnackbarEvent {
  color: string;
  id: string;
  text: string;
  timeout: number | null;
  undo: () => void | null;
  undoText: string | null;
}

export default Vue.extend({
  name: 'Snackbar',

  data() {
    return {
      color: '',
      text: '',
      timeout: null as number | null,
      undoMethod: null as (() => void) | null,
      undoText: this.$t('Undo') as string | null,
      visible: false
    }
  },

  computed: {
    smartTimeout(): number {
      return typeof this.timeout === 'number' ? this.timeout : 5000
    }
  },

  created() {
    eventHub.$on('triggerSnackbar', this.trigger)
  },

  methods: {
    trigger(e: SnackbarEvent) {
      Vue.set(this, 'color', this.$vuetify.theme.themes.light[e.color])
      Vue.set(this, 'text', e.text)
      Vue.set(this, 'timeout', e.timeout)
      Vue.set(this, 'undoMethod', e.undo)
      if(e.undoText)
        Vue.set(this, 'undoText', e.undoText)
      Vue.set(this, 'visible', true)
    },
    undo() {
      this.visible = false
      if (typeof this.undoMethod === 'function') this.undoMethod()
    }
  },

  watch: {
    visible(val) {
      if (val) setTimeout(() => { this.visible = false }, this.smartTimeout)
    }
  }
})
